import React, {Component} from 'react';
import { AccountOrderTable, AccountOrderTableCurrency } from './accountordertable';
import { getAccountCurrentAskOrders , getAccountCurrentBidOrders } from '../common/ardorinterface';

import Grid from '@material-ui/core/Grid';
import { Typography } from '@material-ui/core';
import { NQTDIVIDER } from '../common/constants';



export class AccountOrderBook extends Component {
  constructor(props) {
    super(props);
    this.state={
      bidOrders:[],
      askOrders:[]
    }
    this.refresh = this.refresh.bind(this);
  }

  refresh(){
    var self = this;
    getAccountCurrentAskOrders(this.props.nodeurl,this.props.user.accountRs)
    .then((response) => {
        self.setState({askOrders:response.askOrders});
    });
    getAccountCurrentBidOrders(this.props.nodeurl,this.props.user.accountRs)
    .then((response) => {
        self.setState({bidOrders:response.bidOrders});
    });
  }
    
  componentDidMount(){
    this.refresh()
    console.log("AccountOrderBook: start refresh");
    this.timer = setInterval(this.refresh, 12000)
  }

  componentWillUnmount(){
    console.log("AccountOrderBook: stop refresh");
    clearInterval(this.timer);
  }

  render(){
    return (
      <div style={{textAlign:"center", paddingTop:5, width:"100%", display:"inline-block",   justifyContent:'center', alignItems:'center'}}>
      <Grid container
        justify="space-evenly"
        alignItems="center"
        direction="column"
        spacing={8}
      >
        <Grid item>
          &nbsp;
          <Typography variant="overline">
            Asks
          </Typography>
            <AccountOrderTable orders={this.state.askOrders} type="ask"
                                userAccount={this.props.user.accountRs} NQTdivider={NQTDIVIDER}
                                collectionAssets={this.props.collectionAssets}
                                cards={this.props.cards} 
                                nodeurl={this.props.nodeurl}/>
                                    &nbsp;
        </Grid>
        <Grid item>
        &nbsp;
        <Typography variant="overline">
            
            Bids
          </Typography>
            <AccountOrderTable orders={this.state.bidOrders} type="bid"
                                userAccount={this.props.user.accountRs} NQTdivider={NQTDIVIDER}
                                collectionAssets={this.props.collectionAssets}
                                cards={this.props.cards} 
                                nodeurl={this.props.nodeurl}/>
                                    &nbsp;
        </Grid>
    </Grid> 
    </div>);
  }
};


export class AccountOrderBookCurrency extends Component {
  constructor(props) {
    super(props);
    this.state={
      bidOrders:[],
      askOrders:[]
    }
    this.refresh = this.refresh.bind(this);
  }

  refresh(){
    var self = this;
    getAccountCurrentAskOrders(this.props.nodeurl,this.props.user.accountRs)
    .then((response) => {
        self.setState({askOrders:response.askOrders});
    });
    getAccountCurrentBidOrders(this.props.nodeurl,this.props.user.accountRs)
    .then((response) => {
        self.setState({bidOrders:response.bidOrders});
    });
  }
    
  componentDidMount(){
    this.refresh()
    console.log("AccountOrderBook: start refresh");
    this.timer = setInterval(this.refresh, 12000)
  }

  componentWillUnmount(){
    console.log("AccountOrderBook: stop refresh");
    clearInterval(this.timer);
  }

  render(){
    return (
      <div style={{textAlign:"center", paddingTop:5, width:"100%", display:"inline-block",   justifyContent:'center', alignItems:'center'}}>
      <Grid container
        justify="space-evenly"
        alignItems="center"
        direction="column"
        spacing={8}
      >
        <Grid item>
          &nbsp;
          <Typography variant="overline">
            Asks
          </Typography>
            <AccountOrderTableCurrency orders={this.state.askOrders} type="ask"
                                userAccount={this.props.user.accountRs} NQTdivider={NQTDIVIDER}
                                collectionAssets={this.props.collectionAssets}
                                cards={this.props.cards} 
                                nodeurl={this.props.nodeurl}/>
                                    &nbsp;
        </Grid>
        <Grid item>
        &nbsp;
        <Typography variant="overline">
            
            Bids
          </Typography>
            <AccountOrderTableCurrency orders={this.state.bidOrders} type="bid"
                                userAccount={this.props.user.accountRs} NQTdivider={NQTDIVIDER}
                                collectionAssets={this.props.collectionAssets}
                                cards={this.props.cards} 
                                nodeurl={this.props.nodeurl}/>
                                    &nbsp;
        </Grid>
    </Grid> 
    </div>);
  }
}



